import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { plansNeedRefreshedFromBackend } from 'src/app/angular-elements/plan-selection/configs/reducers/plans.reducer';

import { setEffectiveDate } from 'src/app/angular-elements/shared/components/configs/reducers/effective-date.reducer';
import { EffectiveDateStateStructure } from '../../shared/components/configs/interfaces/effective-date.state-structure.interface';
import { DateService } from 'src/app/shared/services/date.service';
import { ReducerUtilityService } from '../../../shared/utility-services/reducer-utility.service';
import { CommonUtilityService } from '../../../shared/utility-services/common-utility.service';
import { ShoppingDateStateStructure } from '../../shared/components/configs/interfaces/shopping-date.state-structure.interface';
import { SHOPPING_DATE_STATE_NAME } from '../../shared/components/configs/reducers/shopping-dates.reducer';

import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-year-selection',
    templateUrl: './year-selection.component.html',
    styleUrls: ['./year-selection.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})

export class YearSelectionComponent extends GlobalShadowStyleDirective implements OnInit {
  @Input() currentYearOverride: string;
  @Input() selectYearHeading: string;
  @Input() selectYearPrompt: string;
  @Input() initialYearSelection: string = 'nextYear';
  @Input() tooltipText: string;

  yearA: string;
  yearB: string;
  yearSelected: string;
  effectiveDate: EffectiveDateStateStructure;

  showYearSelector: boolean = true;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private ngRedux: NgRedux<StateStructure>,
    private commonUtility: CommonUtilityService,
    private date: DateService) {
      super();
    }

  ngOnInit() {
    const shoppingDates: ShoppingDateStateStructure = this.reducerUtilityService.getApplicationStates()[SHOPPING_DATE_STATE_NAME];
    if (!this.commonUtility.shouldShowYearSelectorByDates(shoppingDates)) {
      this.showYearSelector = false;
      return;
    }

    this.currentYearOverride = this.currentYearOverride?.slice(0, 4);
    this.currentYearOverride = isNaN(Number(this.currentYearOverride)) ? null : this.currentYearOverride;

    this.yearA = this.currentYearOverride || this.date.getFirstOfNextMonth().year().toString();
    this.yearB = (Number(this.yearA) + 1) + '';

    const effectiveDateState: EffectiveDateStateStructure = this.reducerUtilityService.getApplicationStates().EffectiveDate;
    this.effectiveDate = effectiveDateState || {} as EffectiveDateStateStructure;
    this.yearSelected = this.effectiveDate.effectiveDateYear || this.date.getTodayAsMoment().get('year').toString();

    if (!this.effectiveDate.dirtyEffectiveDate) {
      switch (this.initialYearSelection) {
        case 'nextYear':
          this.yearSelected = this.yearB;
          this.saveYearSelectionToState(this.yearB);
          break;
        case 'thisYear':
          this.yearSelected = this.yearA;
          this.saveYearSelectionToState(this.yearA);
          break;
      }
    }
  }

  async saveYearSelectionToState(toggleValue) {
    this.effectiveDate.effectiveDateYear = toggleValue;

    if (toggleValue === this.yearA) {
      const today = this.date.getTodayAsMoment().year(Number(this.yearA));
      this.ngRedux.dispatch(setEffectiveDate(today.format('YYYY-MM-DD').toString()));
    } else {
      this.ngRedux.dispatch(setEffectiveDate(this.effectiveDate.effectiveDateYear + '-01' + '-01'));
    }

    this.date.setDirtyEffectiveDate();
    this.ngRedux.dispatch(plansNeedRefreshedFromBackend(true));
  }
}
